import styled, { css } from 'styled-components'

import theme, { rem } from '../../utils/theme'
import StackedNavItem from './StackedNavItem'

const StyledStackedNav = styled.ul.withConfig({
  shouldForwardProp: prop => !['isCompact'].includes(prop),
})`
  display: block;
  list-style: none;
  margin: 0;
  padding: 0;
  --nav-item-font-size: ${theme.typography.fontSizeSm};
  --nav-item-height: ${rem(36)};
  --nav-item-child-height: ${rem(36)};
  --nav-item-spacing: ${rem(10)};
  --nav-item-padding: 0 ${rem(16)} 2px;
  --nav-list-spacing: ${rem(10)};

  &:not(:first-child) {
    margin-top: ${rem(12)};
  }

  ${props =>
    props.isCompact &&
    css`
      --nav-item-font-size: ${theme.typography.fontSizeSm};
      --nav-item-height: ${rem(30)};
      --nav-item-spacing: 0;
      --nav-item-padding: 0 ${rem(10)};
    `}
`

function StackedNav({ items, isCompact = false, openItemWithActiveChild, children, isCollapsed }) {
  return (
    <StyledStackedNav isCompact={isCompact}>
      {!items && children && children}
      {/* biome-ignore lint/complexity/useOptionalChain: TODO */}
      {items &&
        items.map((item, i) => {
          const { show = true } = item
          if (!show) return null
          return (
            <StackedNavItem
              key={`${item.label}.${
                // biome-ignore lint/suspicious/noArrayIndexKey: TODO: pre-existing, address separately
                i
              }`}
              openItemWithActiveChild={openItemWithActiveChild}
              {...item}
              isCollapsed={isCollapsed}
            />
          )
        })}
    </StyledStackedNav>
  )
}

export default StackedNav
